<template>
	<div class="award">
		<div class="award__table award__list">
			<table class="simple-table">
				<thead>
					<tr>
						<th class="award__list__num">항번</th>
						<th class="award__list__name">1차카테고리명</th>
						<th class="award__list__summary">총평</th>
						<th class="award__list__image">
							어워드모듈 배경이미지 (1080 x 1350)
						</th>
						<th class="award__list__sort">정렬순서</th>
						<th class="award__list__btn">수정</th>
						<th class="award__list__btn">삭제</th>
						<th class="award__list__categoryNum">
							하위카테고리갯수
						</th>
						<th class="award__list__btn">2차 이동</th>
					</tr>
				</thead>
				<tbody>
					<tr
						v-for="(first, idx) in getFirstCategoryList"
						:key="first.idHitCategory"
					>
						<td class="award__list__num">
							{{ first.idHitCategory }}
						</td>
						<td class="award__list__name">
							<input
								v-model="first.categoryText"
								@input="getFirstCategory(idx, $event)"
								type="text"
							/>
						</td>
						<td class="award__list__summary">
							<textarea
								v-model="first.categorySummary"
								@input="getSummary(idx, $event)"
								rows="5"
								type="text"
							></textarea>
						</td>
						<td class="award__list__image">
							<ImageExif
								:src="first.imgPath"
								v-if="first.imgPath"
								class="award__list__thumbnail"
								@click.native="viewOriginImg(first.imgPath)"
							/>
							<input
								placeholder="어워드 모듈 이미지"
								type="file"
								ref="awardModule"
								@change="handleFileChange($event, idx)"
							/>
						</td>
						<td class="award__list__sort">
							<input
								v-model="first.sortKey"
								@input="getSortKey(idx, $event)"
								type="text"
							/>
						</td>
						<td class="award__list__btn">
							<button
								@click="modifyFirstCategory(idx)"
								class="btn orange"
							>
								수정
							</button>
						</td>
						<td class="award__list__btn">
							<button
								@click="deleteFirstCategory(idx)"
								class="btn gray"
								:disabled="!!first.childrenCount"
							>
								삭제
							</button>
						</td>
						<td class="award__list__categoryNum">
							{{ first.childrenCount }}개
						</td>
						<td class="award__list__btn">
							<button
								class="btn mint"
								@click="moveSecondCategory(idx)"
							>
								이동
							</button>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>
<script>
	import debounce from 'lodash/debounce';
	import ImageExif from '@/components/ImageExif.vue';
	import { mapState, mapGetters } from 'vuex';
	import Util, { imageUpload } from '@/util';

	export default {
		name: 'AwardFirstCategory',
		data() {
			return {
				categoryList: [],
				categoryNameList: [],
				categorySummaryList: [],
				categorySortList: [],
				moduleDoc: [],
			};
		},
		props: {
			awardId: {
				default: 0,
			},
		},
		components: {
			ImageExif,
		},

		computed: {
			...mapState('award', ['firstCategoryList']),
			...mapGetters('award', ['getFirstCategoryList']),
		},

		watch: {
			firstCategoryList() {
				const imageHost = `${this.$store.state.env.IMAGE_STORAGE_PATH}`;

				this.firstCategoryList.forEach((item, idx) => {
					this.categoryNameList[idx] = item.categoryText;
					this.categorySummaryList[idx] = item.categorySummary;
					this.categorySortList[idx] = item.sortKey;
					this.moduleDoc[idx] = JSON.parse(item?.doc);
				});
			},
		},

		methods: {
			getFirstCategory: _.debounce(async function (index, event) {
				this.categoryNameList[index] = event.target.value;
			}, 100),
			getSummary: _.debounce(async function (index, event) {
				this.categorySummaryList[index] = event.target.value;
			}, 100),
			getSortKey: _.debounce(async function (index, event) {
				this.categorySortList[index] = event.target.value;
			}, 100),

			init() {
				this.$refs.awardModule.forEach(item => {
					item.value = '';
				});
			},

			async modifyFirstCategory(index) {
				if (!confirm('정말 수정하시겠습니까?')) return;
				try {
					if (isNaN(this.categorySortList[index]))
						return '정렬순서는 숫자만 가능합니다.';
					const number = this.firstCategoryList[index].idHitCategory;
					const params = {
						categoryText: this.categoryNameList[index],
						categorySummary: this.categorySummaryList[index],
						sortKey: this.categorySortList[index],
						moduleFirstCategoryFileDir:
							this.moduleDoc[index]?.moduleFirstCategoryFileDir,
						moduleFirstCategoryFileSaveName:
							this.moduleDoc[index]
								?.moduleFirstCategoryFileSaveName,
					};
					await this.$axiosAdmin2.put(
						`/api/award/firstcategory/${this.awardId}/${number}`,
						params
					);
					alert('수정되었습니다.');
					this.init();
					this.getList();
				} catch (err) {
					console.error(err);
					alert(
						'수정 실패하였습니다. 지속적으로 문제 발생시 개발팀에 문의바랍니다.'
					);
				}
			},
			async deleteFirstCategory(index) {
				if (!confirm('정말 삭제하시겠습니까?')) return;
				try {
					const number = this.firstCategoryList[index].idHitCategory;
					await this.$axiosAdmin2.delete(
						`/api/award/firstcategory/${this.awardId}/${number}`
					);
					alert('삭제되었습니다.');
					this.getList();
				} catch (err) {
					console.error(err);
					alert(
						'삭제 실패하였습니다. 지속적으로 문제 발생시 개발팀에 문의바랍니다.'
					);
				}
			},
			async getList() {
				await this.$store.dispatch(
					'award/getFirstCategory',
					this.awardId
				);
			},
			moveSecondCategory(index) {
				const number = this.firstCategoryList[index].idHitCategory;
				this.$router.push(
					`/product/manage-awards/secondCategory?idHitProduct=${this.awardId}&idHitCategory=${number}`
				);
			},
			viewOriginImg(imgPath) {
				const img = [imgPath];
				if (!imgPath) {
					alert(
						'이미지 불러오기에 실패하였습니다. 지속적인 문제 발생시 개발팀에 문의바랍니다.'
					);
				} else {
					Util.popupImages(img, 500, true);
				}
			},
			readFile(file, index) {
				return new Promise(resolve => {
					const reader = new FileReader();
					reader.onload = e => {
						const file = new Image();
						file.src = e.target.result;

						file.onload = () => {
							const width = file.width;
							const height = file.height;

							const setWidth = 1080;
							const setHeight = 1350;

							if (setWidth !== width || setHeight !== height) {
								alert(
									`이미지 사이즈가  ${setWidth} x ${setHeight}가 아닙니다`
								);
								this.$refs.awardModule[index].value = '';
								return;
							}
							resolve(e);
						};
					};
					reader.readAsDataURL(file);
				});
			},
			addImg(urlList, files, index) {
				const list = urlList.map((url, idx) => {
					const srcObj = {
						src: url,
						fileObject: files[idx],
						extension: files[idx].type.split('/').pop(),
					};
					return srcObj;
				});
				this.uploadImage(list[0], index);
			},
			async uploadImage(imageObj, index) {
				const { extension, fileObject } = imageObj;

				try {
					const res = await imageUpload(
						extension,
						'module-img',
						fileObject
					);
					const filePath = `/${res.config.data.get('key')}`;
					const fileSaveName = filePath.split('/').pop();
					const imgPath = filePath.replace(/\/[^/]+\/?$/, '');

					if (!this.moduleDoc[index]) {
						this.moduleDoc[index] = {
							moduleFirstCategoryFileDir: '',
							moduleFirstCategoryFileSaveName: '',
						};
					}

					this.moduleDoc[index].moduleFirstCategoryFileDir = imgPath;
					this.moduleDoc[index].moduleFirstCategoryFileSaveName =
						fileSaveName;
				} catch (err) {
					console.error(err);
				}
			},
			async handleFileChange(event, index) {
				const files = [...event.target.files];
				const readFileList = await Promise.all(
					files.map(file => this.readFile(file, index))
				);
				const urlList = readFileList.map(({ target }) => target.result);
				this.addImg(urlList, files, index);
			},
		},
	};
</script>
<style lang="scss" scoped>
	.award {
		&__table {
			margin-top: 20px;
			.simple-table {
				th {
					text-align: center;
					padding: 0;
				}
			}
		}

		&__summary {
			textarea {
				height: 290px;
			}
		}

		&__list {
			margin-top: 70px;
			&__btn {
				width: 30px;
				text-align: center;
				button {
					&:disabled {
						border: none;
					}
				}
			}
			&__num {
				width: 30px;
				text-align: center;
			}
			&__name {
				width: 300px;
			}
			&__sort {
				width: 70px;
			}
			&__image {
				width: 300px;
			}
			&__thumbnail {
				width: 200px;
				text-align: center;
				margin: 0 auto 20px;
				cursor: pointer;
			}
			&__categoryNum {
				width: 100px;
				text-align: center;
			}
		}
	}
</style>
